import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()

const store = {
  state: {
    ventasMostrador:{},
    indiceTicketsVentasMostrador:[],
  },
  getters: {
    ventasMostrador: state => state.ventasMostrador,
    indiceTicketsVentasMostrador: state => state.indiceTicketsVentasMostrador,
  },
  mutations: {
    ASIGNA_VENTAS_MOSTRADOR(state,ventas){
      state.ventasMostrador = ventas
    },
    ASIGNA_INDICE_TICKETS_VENTAS_MOSTRADOR(state,data){
      state.indiceTicketsVentasMostrador = data;
    },
  },
  actions: {

    async guardarVentaMostrador({ getters }, ventas) {

      const {id_almacen, id} = getters.usuario

      ventas.id_almacen = id_almacen
      ventas.id_creador = id;
      
      return await db.collection(FS_COLLECTIONS.FRANQUICIAS)
      .doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.VENTAS_MOSTRADOR)
      .add(ventas)

    },
    async actualizarVentaMostrador({getters},payload){

      const {idVenta, venta} = payload

      return await db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.VENTAS_MOSTRADOR).doc(idVenta).update(venta)

    },
    async eliminarVentaMostrador({getters},idVenta){

      const venta = {
        servicio_generico:{
            activo:false,
        }
      }

      return await db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
      .collection(FS_COLLECTIONS.VENTAS_MOSTRADOR).doc(idVenta).set(venta,{merge:true})

    },
    obtenerVentasMostrador({getters, commit}, fecha ){

      return new Promise((resolve) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.VENTAS_MOSTRADOR_INDICES).onSnapshot(snapshot => {

          let ventas = {}

          snapshot.docs.map(doc => {
            ventas = {...ventas,...doc.data()}
          })

          commit('ASIGNA_VENTAS_MOSTRADOR',ventas || {})
          resolve()

        })

      })

    },
    obtenerVentaMostrador({getters},id){

      console.log("Obtener venta mostrador ", id)

      return new Promise((resolve,reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.VENTAS_MOSTRADOR).doc(id).get().then(doc => {

          doc.exists ? resolve(doc.data()) : reject("El documento no existe")

        }).catch(e => {
          reject(e)
        })

      })

    },
    obtenerIndiceTicketsVentaMostrador({getters, commit},anio){

      return new Promise((resolve) => {
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id).
        collection(FS_COLLECTIONS.TICKETS_VENTAS_MOSTRADOR_INDICES).onSnapshot(snapshot => {

          const tickets = [];

          snapshot.docs.map(doc => {

            const ticket = doc.data();
            
            for(const i in ticket){
              const item = ticket[i];
              item.ticket = i;
              tickets.push(item);
            }

          })

            commit('ASIGNA_INDICE_TICKETS_VENTAS_MOSTRADOR',tickets)
            resolve()
            
        })
      })
  
    }
  },
}

export default store



// WEBPACK FOOTER //
// ./src/store/venta_mostrador/index.js